import logo from 'assets/images/NihulKavLogo.png';

const Logo = ({ width = 100 }: { width?: number }) => <img src={logo} alt="NihulKav" width={width} />;

export default Logo;
